import React, { useState } from "react";
import Button from "@mui/material/Button";
import RefreshIcon from "@mui/icons-material/Refresh";
import { keyframes } from "@emotion/react";
import { styled } from "@mui/material/styles";

// Define the spin animation using keyframes
const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

// Create a styled component for the spinning icon
const SpinningIcon = styled(RefreshIcon)<{ isSpinning: boolean }>(
  ({ isSpinning }) => ({
    animation: isSpinning ? `${spin} 1s linear infinite` : "none",
  })
);

interface ReloadButtonProps {
  handleClick: () => void;
  isSpinning : boolean
  setIsSpinning : React.Dispatch<React.SetStateAction<boolean>>
}

const ReloadButton: React.FC<ReloadButtonProps> = ({ handleClick,isSpinning,setIsSpinning }) => {

  const handleButtonClick = () => {
    setIsSpinning(true);
    handleClick();
    setTimeout(() => {
      setIsSpinning(false);
    }, 1000); // Adjust the timeout duration as needed
  };

  return (
    <SpinningIcon
      sx={{ color: "#ffffff" }}
      onClick={handleButtonClick}
      isSpinning={isSpinning}
    />
  );
};

export default ReloadButton;
